import { AlertDetailsWebComponent } from './component/AlertDetailsWebComponent';

export { AlertDetailsWebComponent };
